import { useTranslation, withTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { isEditState, popState, writingTypeState } from "recoil/contentsAtom";
import { checkPosition, naverAuthorizePopUp } from "utils/CommonFunc";
import {
  isLoginStateSelector,
  naverAuthorizeUrl,
  userIdState,
  userNicknameState,
  userProfileImgState
} from "recoil/userInfoAtom";
import { useLoginCheck } from "hooks/useLoginCheck";

function CommonInput(props: { type: string }) {
  const { t } = useTranslation();
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const userId = useRecoilValue(userIdState);
  const userNickname = useRecoilValue(userNicknameState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const userProfileImg = useRecoilValue(userProfileImgState);
  const isNotLogin = useLoginCheck();

  const openModal = () => {
    setPopOpen(true);
    setWritingType(props.type);
    setIsEdit(false);
  };

  const checkLogin = () => {
    if (!isLoginState.isLogIn) {
      isNotLogin();
      return;
    }

    setPopOpen(true);
  };

  const naverAuthorizeCheck = () => {
    checkPosition();
    naverAuthorizePopUp(naverAuthorize);
  };

  const resultType = (type: string) => {
    let result = { placeholder: "", onClick: () => {} };

    switch (type) {
      case "login":
        result.placeholder = "please_login";
        result.onClick = checkLogin;
        break;

      case "reply":
        result.placeholder = "Please_leave_a_reply";
        result.onClick = openModal;
        break;

      case "content":
        result.placeholder = `[${
          userNickname === "" ? userId : userNickname
        }] ${t("would_you_like_to_publish_this_post")}`;
        result.onClick = openModal;
        break;

      case "privacyAgree":
        result.placeholder = "need_agreement_to_terms";
        result.onClick = naverAuthorizeCheck;
        break;

      case "profile":
        result.placeholder = `[${
          userNickname === "" ? userId : userNickname
        }] 나누고 싶은 이야기를 남겨보세요`;
        result.onClick = openModal;
        break;

      default:
        result.placeholder = "please_login";
        result.onClick = checkLogin;
        break;
    }

    return result;
  };

  return (
    <div className="commentWrap">
      <img
        className="user-pic"
        src={
          userProfileImg.length !== 0
            ? userProfileImg
            : "//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        }
        alt="user icon"
      />
      <input
        onClick={resultType(props.type).onClick}
        type="text"
        placeholder={t(resultType(props.type).placeholder)}
        readOnly={true}
      />
    </div>
  );
}

export default withTranslation()(CommonInput);
